var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTasksComplete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00d89a;}.cls-2{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:90px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_184",
    "data-name": "Layer 184"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 302.23,
    cy: 300.36,
    r: 299.73,
    transform: "translate(-123.86 301.68) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "154.32 302.73 272.07 405.42 445.22 193.31"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasksComplete);
export default __webpack_public_path__ + "static/media/tasks_complete.4d85ff0cf2c9468c3165db60f1462d06.svg";
export { ForwardRef as ReactComponent };